<div class="modal-header">
    <p class="modal-title"><strong>Milestones</strong></p>
       <button type="button" (click)="modal.dismiss()" class="btn-close" aria-label="Close"></button>

</div>


<div class="modal-body pl-5">
    <ng-container *ngIf="milestones.length > 0; else noMilestones">
        <h6 class="mb-3">Milestone Title</h6>
        <div class="milestones">
            <div class="line"></div>
            <ul>
                <li *ngFor="let milestone of milestones" [ngClass]="{'completed': milestone.status === 3 }">
                    <span *ngIf="milestone.status === 3"><i class="material-icons">check</i> </span>
                    <span *ngIf="milestone.status === 0"></span>
                    <div class="content">
                        <h6>{{milestone.activityHeader}}</h6>
                        <p *ngIf="milestone.completedDate;else noDateContent">{{milestone.completedDate | date}}</p>
                        <ng-template #noDateContent>
                            <p>
                                Not completed yet
                            </p>
                        </ng-template>
                    </div>
                </li>
            </ul>
        </div>
    </ng-container>

    <ng-template #noMilestones>
        <div class="text-center">
            <p>No Miltsones for now.</p>
        </div>
    </ng-template>

</div>